import React from 'react';
import { images, data } from '../../constants';
import { SubHeading, MenuItem } from '../../components';

import './Services.css';

const Services = () => (
  <div className='app__services app__bg flex__center section__padding' id='service'>
    <div className='app__services-title'>
      <SubHeading title="Prices may vary based on add-ons (Consult with technician for any concerns)" />
      <h1 className='headtext__cormorant'>Services</h1>
    </div>

    <div className='app__services-menu'>
      {/* Manicure Section */}
      <div className='app__services-menu_manicure flex__center'>
        <p className='app__services-menu_heading' >Manicures</p>
        <div className='app__services-menu_items' >
          {data.manicure.map((mani, index) => (
            <MenuItem key={mani.title + index} title={mani.title} price={mani.price} tags={mani.tags} />
          ))}
        </div>
      </div>

      {/* Image Section */}
      <div className='app__services-menu_img'>
        {/* <img src={images.menu} alt='menu img' /> */}
      </div>

      {/* Pedicure Section */}
      <div className='app__services-menu_pedicure flex__center'>
        <p className='app__services-menu_heading'>Pedicures</p>
        <div className='app__services-menu_items'>
          {data.pedicure.map((pedi, index) => (
            <MenuItem key={pedi.title + index} title={pedi.title} price={pedi.price} tags={pedi.tags} />
          ))}
        </div>
      </div>
    </div>



    <div className='app__services-menu'>
      {/* Add Full Sets Section Below Current Services */}
      <div className='app__services-menu_fullsets flex__center'>
        <p className='app__services-menu_heading'>Full Sets</p>
        <div className='app__services-menu_items'>
          {data.fullsets.map((fullset, index) => (
            <MenuItem key={fullset.title + index} title={fullset.title} price={fullset.price} tags={fullset.tags} />
          ))}
        </div>
      </div>

      {/* Image Section */}
      <div className='app__services-menu_img'>
        {/* <img src={images.menu} alt='menu img' /> */}
      </div>

      {/* Add Waxing Section Below Full Sets */}
      <div className='app__services-menu_waxing flex__center'>
        <p className='app__services-menu_heading'>Waxing</p>
        <div className='app__services-menu_items'>
          {data.waxing.map((wax, index) => (
            <MenuItem key={wax.title + index} title={wax.title} price={wax.price} tags={wax.tags} />
          ))}
        </div>
      </div>
    </div>

    <div className='app__services-menu'>
      {/* Add Misc Section Below Current Services */}
      <div className='app__services-menu_misc flex__center'>
        <p className='app__services-menu_heading'>Face</p>
        <div className='app__services-menu_items'>
          {data.face.map((face, index) => (
            <MenuItem key={face.title + index} title={face.title} price={face.price} tags={face.tags} />
          ))}
        </div>
      </div>

      {/* Image Section */}
      <div className='app__services-menu_img'>
        {/* <img src={images.menu} alt='menu img' /> */}
      </div>

      {/* Add Add-Ons Section Below Full Sets */}
      <div className='app__services-menu_addons flex__center'>
        <p className='app__services-menu_heading'>Add-Ons</p>
        <div className='app__services-menu_items'>
          {data.addons.map((add, index) => (
            <MenuItem key={add.title + index} title={add.title} price={add.price} tags={add.tags} />
          ))}
        </div>
      </div>
    </div>



    <div style={{ marginTop: '15px' }}>
      {/* <button type='button' className='custom__button'>View More</button> */}
    </div>
  </div>
);

export default Services;
